import { httpGet } from '../../../modules/api/axios_api';
import Constants, { fixProtocol } from '../../../constants/constants';
import { MeasurementParameters, MeasurementsData } from './types';

/**
 * Retrieves user measurement analytics
 *
 * @method getMeasurementData
 * @memberof Measurement
 * @param  {number} patient_id - Patient user ID
 * @param  {string} measurement_identifier - Measurement to get data on
 * @param  {MeasurementParameters} parameters - Data filter parameters
 * @returns {Promise<MeasurementsData>} - Filtered user measurement data
 */

export const getMeasurementData = (
  patient_id: number,
  measurement_identifier: string,
  parameters: MeasurementParameters
): Promise<MeasurementsData> => {
  const url = new URL(
    `${fixProtocol(Constants.BACKEND_URL)}/analytics/measurements/${patient_id}/${measurement_identifier}`
  );

  const params = new URLSearchParams(url.search);

  parameters?.date_range && params.append('date_range', parameters.date_range);
  parameters?.session && params.append('session', parameters.session);

  return httpGet(`${url.href}?${params.toString()}`, {})
    .then((results) => {
      if (results?.data.success) {
        return results.data.result;
      }
    })
    .catch((error) => {
      throw new Error(`Error getting measurement ${error}`);
    });
};
